import { cn } from '#app/utils/misc.tsx'

type GoldRuleProps = {
	variant?: 'short' | 'long'
	className?: string
}

export function GoldRule({ variant = 'short', className }: GoldRuleProps) {
	return (
		<hr
			className={cn(
				'm-0 border-0',
				variant === 'long' ? 'gold-rule-long' : 'gold-rule',
				className,
			)}
			aria-hidden="true"
		/>
	)
}
